// Show & hide nav
function mobileNav(button, target) {
  button = document.getElementById(button)
  target = document.getElementById(target)
  const topLevelHeader = document.querySelector('.header-toplevel')
  const logo = topLevelHeader.querySelector('#logo')
  const mainNav = topLevelHeader.querySelector('#nav')

  if (button.length === 0 || target.length === 0) {
    return
  }

  const content = button.querySelector('.content')

  button.addEventListener('click', () => {
    const wasCollapsed = content.textContent === 'Ouvrir le menu'
    content.textContent = wasCollapsed ? 'Fermer le menu' : 'Ouvrir le menu'

    button.setAttribute(
      'aria-expanded',
      button.getAttribute('aria-expanded') === 'false'
    )
    button.classList.toggle('is-active')
    target.classList.toggle('nav-is-collapsed')
    target.classList.toggle('nav-is-displayed')
    if (wasCollapsed) {
      topLevelHeader.insertAdjacentElement('afterend', mainNav)
    } else {
      logo.insertAdjacentElement('afterend', mainNav)
    }
  })
}

export function initMobileNav() {
  const jsButton = document.createElement('button')
  jsButton.setAttribute('type', 'button')
  jsButton.setAttribute('aria-expanded', false)
  jsButton.setAttribute('aria-controls', 'nav')
  jsButton.setAttribute('id', 'toggle-nav')
  jsButton.setAttribute('class', 'hamburger')
  jsButton.insertAdjacentHTML(
    'beforeend',
    `<span class="content">Ouvrir le menu</span>
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>`
  )
  const navContainer = document.querySelector('.header-toplevel')
  navContainer.insertAdjacentElement('beforeend', jsButton)
  document.getElementById('header').classList.add('nav-is-collapsed')

  mobileNav('toggle-nav', 'header')
}

// INTERNAL NAVIGATION
// ----------------------------

// Collapsable internal nav
export function initInternalNavigation() {
  const internalNav = document.querySelector('.inner-wrapper nav')
  if (!internalNav) return

  const button = internalNav.querySelector('button')
  if (!button) return

  const toc = document.getElementById('toc')
  if (!toc) return

  const tocFirstLink = toc.querySelector('a')

  const navList = internalNav.querySelector('ul')

  button.addEventListener('click', () => {
    const wasCollapsed = button.textContent === 'Voir le sommaire'
    button.textContent = wasCollapsed
      ? 'Masquer le sommaire'
      : 'Voir le sommaire'

    navList.classList.toggle('hidden')
    button.setAttribute(
      'aria-expanded',
      button.getAttribute('aria-expanded') === 'false'
    )
    if (wasCollapsed) {
      tocFirstLink.focus()
    } else {
      button.focus()
    }
  })
}

// Manage Esc keyboard behavior to close opened content (TOC)
export function listenToEscapeEvent() {
  document.addEventListener(
    'keyup',
    (event) => {
      const keyName = event.key

      if (keyName === 'Escape') {
        // Check current (focused) element exists and is inside TOC
        const focusedElement = document.activeElement
        const toc = focusedElement.closest('#toc')

        // TOC was not found? Then stop processing
        if (!toc) return

        const button = document.querySelector('.inner-wrapper nav button')
        if (!button) return

        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
        })
        button.dispatchEvent(clickEvent)
      }
    },
    false
  )
}
